import React, { useState, useEffect } from 'react';
import { X, Mail, User, Loader2, Users } from 'lucide-react';
import { Button } from '../ui/button';

const BACKEND_URL = window.location.origin;

const BuyerItem = ({ buyer }) => (
  <div className="bg-gray-900/50 rounded-lg p-3 border border-gray-700 flex items-center gap-3">
    <div className="w-9 h-9 rounded-full bg-pink-500/20 flex items-center justify-center">
      <User className="w-4 h-4 text-pink-400" />
    </div>
    <div className="flex-1 min-w-0">
      <p className="text-white text-sm truncate">{buyer.name}</p>
      <p className="text-pink-400 text-xs flex items-center gap-1"><Mail className="w-3 h-3" />{buyer.email}</p>
    </div>
    <p className="text-green-400 text-sm font-semibold">${buyer.amount}</p>
  </div>
);

const BookBuyersModal = ({ isOpen, onClose, bookId, bookTitle }) => {
  const [loading, setLoading] = useState(true);
  const [buyers, setBuyers] = useState([]);
  const [revenue, setRevenue] = useState(0);

  useEffect(() => {
    if (isOpen && bookId) {
      setLoading(true);
      fetch(`${BACKEND_URL}/api/books/admin/book-sales/${bookId}`, { credentials: 'include' })
        .then(res => res.json())
        .then(result => {
          setBuyers(result.buyers || []);
          setRevenue(result.total_revenue || 0);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    }
  }, [isOpen, bookId]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/70" onClick={onClose} />
      <div className="relative bg-gray-800 rounded-xl p-5 max-w-lg w-full border border-gray-700">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-bold text-white flex items-center gap-2">
            <Users className="w-5 h-5 text-pink-400" />Buyers
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-white">
            <X className="w-5 h-5" />
          </button>
        </div>
        
        <p className="text-gray-400 text-sm mb-4 truncate" dir="rtl">{bookTitle}</p>
        
        <div className="flex gap-3 mb-4">
          <div className="flex-1 bg-green-500/10 border border-green-500/30 rounded-lg p-3 text-center">
            <p className="text-xl font-bold text-green-400">{buyers.length}</p>
            <p className="text-xs text-gray-400">Sales</p>
          </div>
          <div className="flex-1 bg-pink-500/10 border border-pink-500/30 rounded-lg p-3 text-center">
            <p className="text-xl font-bold text-pink-400">${revenue.toFixed(2)}</p>
            <p className="text-xs text-gray-400">Revenue</p>
          </div>
        </div>

        <div className="max-h-64 overflow-y-auto space-y-2">
          {loading && <div className="flex justify-center py-8"><Loader2 className="w-8 h-8 text-pink-500 animate-spin" /></div>}
          {!loading && buyers.length === 0 && <p className="text-center text-gray-500 py-6">No purchases yet</p>}
          {!loading && buyers.map((b, i) => <BuyerItem key={i} buyer={b} />)}
        </div>

        <Button onClick={onClose} className="mt-4 w-full bg-gray-700 hover:bg-gray-600">Close</Button>
      </div>
    </div>
  );
};

export default BookBuyersModal;
